// Утилита для преобразования времени 'HH:MM' в объект Date с учетом локальной разницы
export function parseTime(time: string, referenceDate: Date): Date | null {
    if(!time) {return null;}
    const [hours, minutes] = time.split(':').map(Number);

    // Копируем referenceDate, чтобы не изменять исходную дату
    const parsedDate = new Date(referenceDate);

    // Устанавливаем часы и минуты, но не учитываем миллисекунды и секунды
    parsedDate.setHours(hours, minutes, 0, 0);

    return parsedDate;
}

export function setDayRange(date: Date | string | number): string {
    const today = new Date(date);
    // Установка начала и конца дня в UTC
    const startOfDay = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0));
    const endOfDay = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59));
    return `$btw:${startOfDay.toISOString()},${endOfDay.toISOString()}`;
}

export function getTimeOffset(): number {
    const offset = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(Math.floor(offset / 60));
    const offsetSign = offset > 0 ? '-' : '+';
    return  Number(`${offsetSign}${offsetHours}`);
}
